import React from 'react';
import { arrayOf, func, string, number, bool, shape, oneOfType, object } from 'prop-types';
import ResultCount from './result-count/';
import SortBy from './sort-by/';

export default function ToolbarSection({ showResultCount, itemCount, sortBy, currentSort, updateSort }) {
    if (!showResultCount && (!sortBy || !sortBy.length)) { return null; }

    return (
        <div className="listing-toolbar">
            <div className="toolbar-container">
                {showResultCount && <ResultCount count={itemCount} />}
                <SortBy
                    items={sortBy}
                    currentSort={currentSort}
                    updateSort={updateSort}
                />
            </div>
        </div>
    );
}

ToolbarSection.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    showResultCount: bool.isRequired,
    itemCount: number.isRequired,
    sortBy: arrayOf(shape({
        label: string.isRequired,
        field: string.isRequired,
        ascending: bool.isRequired
    })),
    currentSort: oneOfType([string, object]),
    updateSort: func.isRequired
    /* eslint-enable react/no-typos */
};

ToolbarSection.defaultProps = {
    sortBy: [],
    currentSort: ''
};
